<template>
  <div class="grid grid-cols-1 md:grid-cols-2 gap-6">
    <div class="p-2">
      <label
        for="address_1"
        class="block text-gray-700 mb-2 font-medium"
      >Address Line 1</label>
      <InputText
        id="address_1"
        :model-value="contact.address?.address_1 || ''"
        :disabled="!isEditing"
        class="w-full"
        @update:model-value="updateAddressField('address_1', $event)"
      />
    </div>
    <div class="p-2">
      <label
        for="address_2"
        class="block text-gray-700 mb-2 font-medium"
      >Address Line 2</label>
      <InputText
        id="address_2"
        :model-value="contact.address?.address_2 || ''"
        :disabled="!isEditing"
        class="w-full"
        @update:model-value="updateAddressField('address_2', $event)"
      />
    </div>
    <div class="p-2">
      <label
        for="city"
        class="block text-gray-700 mb-2 font-medium"
      >City</label>
      <InputText
        id="city"
        :model-value="contact.address?.city || ''"
        :disabled="!isEditing"
        class="w-full"
        @update:model-value="updateAddressField('city', $event)"
      />
    </div>
    <div class="p-2">
      <label
        for="state"
        class="block text-gray-700 mb-2 font-medium"
      >State/County</label>
      <InputText
        id="state"
        :model-value="contact.address?.state || ''"
        :disabled="!isEditing"
        class="w-full"
        @update:model-value="updateAddressField('state', $event)"
      />
    </div>
    <div class="p-2">
      <label
        for="postcode"
        class="block text-gray-700 mb-2 font-medium"
      >Postcode</label>
      <InputText
        id="postcode"
        :model-value="contact.address?.postcode || ''"
        :disabled="!isEditing"
        class="w-full"
        @update:model-value="updateAddressField('postcode', $event)"
      />
    </div>
    <div class="p-2">
      <label
        for="country"
        class="block text-gray-700 mb-2 font-medium"
      >Country</label>
      <InputText
        id="country"
        :model-value="contact.address?.country || ''"
        :disabled="!isEditing"
        class="w-full"
        @update:model-value="updateAddressField('country', $event)"
      />
    </div>
  </div>
</template>

<script setup>
import { defineProps, defineEmits } from 'vue';

const props = defineProps({
    contact: {
        type: Object,
        required: true
    },
    isEditing: {
        type: Boolean,
        default: false
    }
});

const emit = defineEmits(['update:contact']);

const updateAddressField = (field, value) => {
    // Ensure address object exists with both frontend and backend field names
    const currentAddress = props.contact.address || {};
    const updatedAddress = {
        ...currentAddress,
        [field]: value
    };
    
    // Also update the corresponding frontend/backend field name for compatibility
    if (field === 'address_1') {
        updatedAddress.address1 = value;
    } else if (field === 'address1') {
        updatedAddress.address_1 = value;
    } else if (field === 'address_2') {
        updatedAddress.address2 = value;
    } else if (field === 'address2') {
        updatedAddress.address_2 = value;
    } else if (field === 'city') {
        updatedAddress.town = value;
    } else if (field === 'town') {
        updatedAddress.city = value;
    } else if (field === 'state') {
        updatedAddress.county = value;
    } else if (field === 'county') {
        updatedAddress.state = value;
    }
    
    const updatedContact = { 
        ...props.contact, 
        address: updatedAddress
    };
    emit('update:contact', updatedContact);
};
</script> 